export const DATA_HOOKS = {
  GLOBAL_HOOK: 'tpa-components-provider',
  WIDGET_SEARCH_ELEMENT: 'faq-search',
  WIDGET_NO_SEARCH_RESULTS: 'no-search-results',
  QUESTIONS_WRAPPER: 'questions-wrapper',
  NUMBERED_ACCORDION: 'numbered-accordion',
  NUMBERED_ACCORDION_ACCORDION: 'numbered-accordion-accordion',
  NUMBERED_ACCORDION_NUMBER: `numbered-accordion-number`,
  NO_QUESTION_RESULTS: 'no-question-results',
  WIDGET_QUESTIONS_RESULTS_FOUND: 'questions-results-found',
  TEXT_SEARCH_RESULTS_FOUND: 'text-search-results-found',
  WIDGET_HEADER_TITLE: 'header-title',
  WIDGET_HEADER_TITLE_TEXT: 'title',
  WIDGET_CATEGORIES_WRAPPER: 'tabs-wrapper',
  WIDGET_CATEGORIES_VERTICAL: 'faq-tabs-vertical',
  WIDGET_ACCORDION_WRAPPER: 'widget-accordion-wrapper',
  WIDGET_SOCIAL_WRAPPER: 'widget-social-wrapper',
  WIDGET_SOCIAL_BAR: 'widget-social-bar',
  WIDGET_SOCIAL_BAR_FACEBOOK: 'widget-social-bar-facebook',
  WIDGET_SOCIAL_BAR_TWITTER: 'widget-social-bar-twitter',
  WIDGET_SOCIAL_BAR_LINKEDIN: 'widget-social-bar-linkedin',
  WIDGET_SOCIAL_BAR_COPY: 'widget-social-bar-copy',
  WIDGET_LIST_WRAPPER: 'widget-list-wrapper',
  WIDGET_NUMBER_WRAPPER: 'widget-number-wrapper',
  WIDGET_ROOT: 'faq-root',
  WIDGET_CATEGORIES_VERTICAL_ITEM: (index: number) =>
    `category-button-${index}`,
  WIDGET_CATEGORIES_HORIZONTAL: 'faq-tabs',
  WIDGET_ACCORDION_ONE_COLUMN: (key: string) => `accordion-one-column-${key}`,
  WIDGET_LIST_ONE_COLUMN: (key: string) => `list-one-column${key}`,
  LIST_ITEM_QUESTION: (index: number | string) => `list-item-question-${index}`,
  LIST_ITEM_ANSWER: (index: number | string) => `list-item-answer-${index}`,
};
